import { render, staticRenderFns } from "./CartBottomNavigation.vue?vue&type=template&id=36d03393&scoped=true&"
import script from "./CartBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./CartBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CartBottomNavigation.vue?vue&type=style&index=0&id=36d03393&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d03393",
  null
  
)

export default component.exports